module.exports = __webpack_public_path__ + "static/media/publicity.b51c8f2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CopierSelfprinting/publicity.mp4
// module id = Z15v
// module chunks = 10